import {Maybe} from 'graphql/jsutils/Maybe';
import {HTMLAttributes} from 'react';
import {
  AutomaticEvent,
  GetEventInfoPayload,
} from '../../../graphql/generated/types';

export interface EventPageV2ContainerProps {
  contentUrl: string;
  contentInfoList?: Maybe<AutomaticEvent[]>;
  isAlert: boolean;
  alertMessage?: string;
  isNeedUpdate: boolean;
}

export interface EventPageV3ContainerProps {
  hashedEventId: string;
  eventTitle?: Maybe<string>;
}

export interface EventPageV2Props extends HTMLAttributes<HTMLDivElement> {
  contentUrl: string;
  contentInfoList?: Maybe<AutomaticEvent[]>;
  isAlert: boolean;
  onClickContent: (
    e: React.MouseEvent<HTMLElement, MouseEvent>
  ) => Promise<void>;
}

export type Event = GetEventInfoPayload & {
  isAlert: boolean;
  alertMessage?: string;
};

// V3 는 JSTL 문법이 적용된 Template(orgCode) 를 받아와 동적으로 변경되는 Data(IEventV3Data) 로 치환한다.
// 아래 key 는 운영툴에서 이벤트를 생성/수정할 때 그대로 사용하는 key 라서 이름이 변경되거나 삭제되면 안됨
export interface EventV3Data {
  is_alert: boolean;
  eventTitle: Maybe<string>;
  mobileCheck: boolean;
  os: OS;
  is_need_update?: Maybe<boolean>;
  event_id?: Maybe<number>;
  agreed?: Maybe<string>;
  webSourceCache: string;
  content_url: string;
  contextPath: string;
  static_image_server: string;
  alertMessage?: string;
  userUid?: Maybe<number>;
  stoken?: Maybe<string>;
  appUserId?: Maybe<string>;
  nickname?: Maybe<string>;
}

export enum EventVersionType {
  V2 = '2',
  V3 = '3',
}

export type OS = 'I' | 'A' | 'W' | 'U';
